import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Bot, CheckCircle2, XCircle } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card'
import { Button } from '../../components/ui/Button'

export const EmailVerificationPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const status = searchParams.get('status')
  const isSuccess = status === 'success'

  React.useEffect(() => {
    document.title = 'Email Verification - CleverAct AI'
  }, [])

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center space-x-2 group">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-primary to-emerald-500 p-[2px]">
            <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-background">
              <Bot className="h-6 w-6 text-primary" />
            </div>
          </div>
          <span className="text-2xl font-bold text-foreground group-hover:text-foreground/80 transition-colors">
            CleverAct AI
          </span>
        </Link>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            {isSuccess ? (
              <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto mb-2" />
            ) : (
              <XCircle className="h-12 w-12 text-destructive mx-auto mb-2" />
            )}
            <CardTitle className="text-2xl font-bold text-foreground">
              {isSuccess ? 'Email Verified' : 'Verification Failed'}
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-muted-foreground">
              {isSuccess
                ? 'Your email has been verified successfully. You can now sign in.'
                : 'The verification link is invalid or has expired. Please request a new one.'}
            </p>
            <Link to="/auth/login">
              <Button variant="primary" size="lg" className="w-full rounded-full bg-gradient-to-r from-primary to-emerald-500 text-white">
                Go to Login
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default EmailVerificationPage
